// Copyright (c) Move Closer 2022.
import gql from 'graphql-tag'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const LOYALTY_FRAGMENT = gql`
fragment LoyaltyFragment on Customer {
    kameleon
    miles_and_more
    friends_and_family
}
`
